import React, { useEffect, useState } from 'react';

import PageHeader1 from '../../components/common/PageHeader1';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { validateFile } from '../../utils/comman-function';

function AstroRemedy() {
  const BASE_URL = process.env.REACT_APP_BASEURL;
  const getAuthToken = () => localStorage.getItem("astroVani-admin-token");

  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [form, setForm] = useState({
    title: '',
    value: '',
    imageUrl: '',
    isActive: true
  });

  const fetchRemedy = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/admin/astroRemedy`, {
        headers: {
          'Authorization': getAuthToken(),
        },
      });

      if (!response.ok) throw new Error("Failed to fetch Astro Remedy settings");
      const result = await response.json();
      const data = result?.data || result;

      if (data) {
        setForm({
          title: data.title || '',
          value: data.value || '',
          imageUrl: data.imageUrl || '',
          isActive: data.isActive !== undefined ? data.isActive : true
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error(error.message || "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRemedy();
  }, []);

  const handleChange = (field, val) => {
    setForm(prev => ({ ...prev, [field]: val }));
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!validateFile(file, "image")) {
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${BASE_URL}/admin/imageUpload`, {
        method: "POST",
        body: formData,
        headers: {
          'Authorization': getAuthToken(),
        },
      });

      if (!response.ok) throw new Error("Failed to upload image");
      const responseData = await response.json();
      const uploadedUrl = responseData?.data?.img[0];

      if (uploadedUrl) {
        handleChange('imageUrl', uploadedUrl);
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload image.");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error('Title is required');
      return;
    }
    if (!form.value.trim()) {
      toast.error('Value is required');
      return;
    }

    setSubmitLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/admin/astroRemedy`, {
        method: 'PATCH',
        headers: {
          'Authorization': getAuthToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      });

      const result = await response.json();
      if (!response.ok || (result && result.success === false) || (result && result.status === 'error')) {
        throw new Error(result.message || "Failed to update settings");
      }

      toast.success(result.message || "Astro Remedy settings updated successfully!");
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.message || "Failed to update config");
    } finally {
      setSubmitLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-xxl d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-xxl">
      <PageHeader1 pagetitle="Astro Remedy Settings" />

      <form onSubmit={handleSubmit}>
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Configure Astro Remedy</h6>
                {/* <div className="form-check form-switch" style={{ fontSize: "16px" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="astroRemedyIsEnabledToggle"
                    checked={form.isActive}
                    onChange={(e) => handleChange('isActive', e.target.checked)}
                  />
                  <label className="form-check-label ms-2" htmlFor="astroRemedyIsEnabledToggle">
                    Active
                  </label>
                </div> */}
              </div>
              <div className="card-body pt-0">
                <div className="row g-3">
                  <div className="col-md-12">
                    <label className="form-label">Title <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.title}
                      onChange={(e) => handleChange('title', e.target.value)}
                      placeholder="e.g. AstroRemedy"
                      required
                    />
                  </div>
                  {/* <div className="col-md-6">
                    <label className="form-label">Value <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.value}
                      onChange={(e) => handleChange('value', e.target.value)}
                      placeholder="e.g. astroRemedy"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Image URL</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.imageUrl}
                      onChange={(e) => handleChange('imageUrl', e.target.value)}
                      placeholder="Enter image URL or upload image"
                    />
                  </div> */}
                  <div className="col-md-6">
                    <label className="form-label">Upload Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleImageUpload}
                      disabled={uploading}
                    />
                    {uploading && <div className="text-muted small mt-1">Uploading...</div>}
                  </div>
                  {form.imageUrl && (
                    <div className="col-12">
                      <label className="form-label d-block">Image Preview</label>
                      <img
                        src={form.imageUrl}
                        alt="Remedy Preview"
                        style={{
                          maxWidth: '150px',
                          maxHeight: '150px',
                          objectFit: 'contain',
                          borderRadius: '8px',
                          border: '1px solid #ddd',
                          padding: '5px'
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body text-end">
                <button type="submit" className="btn btn-primary px-4" disabled={submitLoading || uploading}>
                  {submitLoading ? 'Saving...' : 'Save Config'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AstroRemedy;
